import React from 'react'
import Navbar from '../shared/Navbar'
import TittleBanner from '../shared/TittleBanner'
import DescBanner from '../shared/DescBanner'
import Footer from '../Footer/footer'
import MaterialTailwindCard from '../shared/Card'
import planning from '../assets/images/cards-bg/planning.jpg'
import consulting from '../assets/images/cards-bg/consullting.jpg'
import supervising from '../assets/images/cards-bg/supervising.jpg'
import interior from '../assets/images/Projekt_8/Scene 1.1.png'

export default function Services() {
  return (
    <div>
      <Navbar/>
      <TittleBanner img="bg-about-us-banner" tiitle="Services"/>
      <DescBanner text="At Arcium Studio, we provide a full range of architectural services to bring your vision to life with precision and creativity. Our planning services ensure that every project starts with a strong foundation, from concept development to detailed architectural designs. With our expertise in interior design, we create stylish and functional spaces that reflect your personality and enhance your lifestyle. Whether you’re looking to renovate an existing structure or restore its original charm, we offer innovative solutions that breathe new life into any space. Our consulting services provide expert guidance on architectural design, materials, and project feasibility to ensure the best results. Additionally, we offer supervising services to oversee every stage of your project, ensuring quality, efficiency, and adherence to design specifications from start to finish. Let’s build something extraordinary together!"/>
  
      
          <h1 className='text-center text-2xl sm:text-3xl font-orbitron mt-16 uppercase'>Our Services</h1>

          <div className='flex justify-center md:justify-between gap-5 p-5 flex-wrap align-middle items-center'>

          <MaterialTailwindCard 
            tittle="Planning" 
            desc="Thoughtful and detailed architectural designs to bring your vision to life."
            img={planning}
            link="/services/planning"
            imageStyle="w-full"
            test="21321132"
            />
          
            <MaterialTailwindCard 
            tittle="Interior" 
            desc="Stylish and functional interiors that reflect your personality and needs."
            img={interior}
            link="/services/interior"
            imageStyle="w-full"
            />
          
            <MaterialTailwindCard 
            tittle="Consulting" 
            desc="Expert guidance to ensure smart decisions and seamless execution."
            img={consulting}
            link="/services/consulting"
            imageStyle="w-full"
            />
            
            <MaterialTailwindCard 
            tittle="Supervising" 
            desc="Professional oversight to maintain quality, efficiency, and precision."
            img={supervising}
            link="/services/supervising"
            imageStyle="w-full"
            />

          </div>
            <Footer/>
   </div>
  )
}
